import React, {Component, Fragment} from 'react';
import AssetsContext from "../../contexts/assets-context";

function withAssets(WrappedComponent) {
  return class extends Component {
    render() {
      return (
        <AssetsContext.Consumer>
          {(assets) => (
            <Fragment>

              <WrappedComponent courses={assets} {...assets} {...this.props}/>
            </Fragment>

          )}
        </AssetsContext.Consumer>
      );
    }
  };
}

export default withAssets;
